export default __webpack_public_path__ + "static/media/logo-exp-ttp.6f75e631.svg";